const numberOfIndividuals = `
query individuals($where: individualWhereInput){
  individuals(where: $where){
    totalCount
  }
}
`

const readAllIndividuals = `
query readAllIndividuals($skip: Int, $limit: Int, $sort: sortInput, $where: individualWhereInput){
  individuals(skip: $skip, limit: $limit, sort: $sort, where: $where){
    totalCount
    list {
        createdAt
        createdBy { 
          associatedUser { id name } 
        }
        lastModifiedBy {
            associatedUser { id name } 
        }
        id
        name
        englishFirstName
        englishLastName
        chineseFirstName
        chineseLastName
        dateOfBirth
        gender
        occupation
        maritalStatus
        employmentStatus
        salutation
        preferredCommunicationChannel
        preferredLanguage
        countryOfResidency
        acceptsMarketing
        contacts { id type value }
        identities { id type value }
        addresses { id fields type }
        facts {
          id
          type
          value{
            stringValue
            numberValue
            booleanValue
            dateValue
            arrayValue {
              stringValue
            }
          }
        }
    }
  }
}
`

const numberOfCompanies = `
query numberOfCompanies($where: companyWhereInput){
  companies(where: $where){
    totalCount
  }
}
`

const readAllCompanies = `
query readAllCompanies($skip: Int, $limit: Int, $sort: sortInput, $where: companyWhereInput){
  companies(skip: $skip, limit: $limit, sort: $sort, where: $where){
    totalCount
    list {
      createdAt
      createdBy { 
        associatedUser { id name } 
      }
      lastModifiedBy {
          associatedUser { id name } 
      }
      id
      name
      registrationNumber
      natureOfBusiness
      acceptsMarketing
      contacts{ id type value }
      addresses{ id fields type }
      facts {
        id
        type
        value{
          stringValue
          numberValue
          booleanValue
          dateValue
          arrayValue {
            stringValue
          }
        }
      }
    }
  }
}
`
const numberOfPolicies = `
query numberOfPolicies($where: policyWhereInput){
  policies(where: $where){
    totalCount
  }
}
`
const readAllQuotes = `
query readAllQuotes($skip: Int, $limit: Int, $sort: sortInput, $where: policyWhereInput){
  policies(skip: $skip, limit: $limit, sort: $sort, where: $where){
    totalCount
    list{
      id
      source
      client { name }
      createdAt
      
      acceptedOffer{
        product {
          name
          insurer { name }
          productId { plan type version }
          benefits { name }
        }
        premium {
          formattedOriginalPrice
          formattedPrice
          originalPrice
          amount
          loadings { originalPrice id flat ratio codeName { code name } currencyCode }
          appliedDiscounts { originalPrice code flat ratio order formattedFlat }
          appliedTaxes { originalPrice code flat ratio order formattedFlat }
          currencyCode
        }
        exclusions { 
          id 
          codeName { code }
          remark 
        }
      }

      holder{
        ... on individual {
          __typename
          name
          gender
          salutation
          englishFirstName
          englishLastName
          chineseFirstName
          chineseLastName
          dateOfBirth
          maritalStatus
          occupation
          countryOfResidency
          acceptsMarketing
          preferredCommunicationChannel
          preferredLanguage
          contacts { type value }
          identities { type value }
          addresses { type fields }
          facts { type value{ stringValue dateValue booleanValue numberValue arrayValue { stringValue } }}
        }

        ... on company {
          __typename
          name
          natureOfBusiness
          registrationNumber
          contacts { type value }
          identities { type value }
          addresses { type fields }
          facts { type value{ stringValue dateValue booleanValue numberValue arrayValue { stringValue } }}
          acceptsMarketing
        }
      }

      #commissions
      commissionSummary {
        type
        currencyCode
        amount
        entity{
          name
        }
        ratio
      }

      transactions{
        id
        formattedTransaction
        currencyCode
        dateTime
        amount
        status
        method
      }

      status
      cancellationReason
      cancelledBy{
        username
        associatedUser{
          name
        }
      }
      rejectionCodes{
        code
        name
      }
      rejectionRemarks
      rejectedBy { username }
      startDate
      endDate
      issueDate
      referrer{ name internalCode }

      insured {
        ... on individual {
          __typename
          name
          gender
          salutation
          englishFirstName
          englishLastName
          chineseFirstName
          chineseLastName
          dateOfBirth
          maritalStatus
          occupation
          countryOfResidency
          acceptsMarketing
          preferredCommunicationChannel
          preferredLanguage
          contacts { type value }
          identities { type value }
          addresses { type fields }
          facts { type value{ stringValue dateValue booleanValue numberValue arrayValue { stringValue } }}
        }

        ... on object {
          __typename
          name
          addresses { type fields }
          facts { type value{ stringValue dateValue booleanValue numberValue arrayValue { stringValue } }}
        }
      }

      otherHolders {
        ... on individual {
          __typename
          name
          gender
          salutation
          englishFirstName
          englishLastName
          chineseFirstName
          chineseLastName
          dateOfBirth
          maritalStatus
          occupation
          countryOfResidency
          acceptsMarketing
          preferredCommunicationChannel
          preferredLanguage
          contacts { type value }
          identities { type value }
          addresses { type fields }
          facts { type value{ stringValue dateValue booleanValue numberValue arrayValue { stringValue } }}
        }
      }
      
      notes{
        id
        title
        content
        createdAt
        createdBy{
          username
        }
        lastModifiedBy{
          username
        }
      }
    }
  }
}
`
const readAllPolicies = `
query readAllPolicies($skip: Int, $limit: Int, $sort: sortInput, $where: policyWhereInput){
  policies(skip: $skip, limit: $limit, sort: $sort, where: $where){
    totalCount
    list{
      id
      source
      client { name }
      createdAt
      issuerNumber
      
      acceptedOffer{
        product {
          name
          insurer { name }
          productId { plan type version }
          benefits { name }
        }
        premium {
          formattedOriginalPrice
          formattedPrice
          originalPrice
          amount
          loadings { originalPrice id flat ratio codeName { code name } currencyCode }
          appliedDiscounts { originalPrice code flat ratio order formattedFlat }
          appliedTaxes { originalPrice code flat ratio order formattedFlat }
          currencyCode
        }
        exclusions { 
          id 
          codeName { code } 
          remark
        }
      }

      contractHolder {
        ...on individual {
          __typename
          name
          gender
          salutation
          englishFirstName
          englishLastName
          chineseFirstName
          chineseLastName
          dateOfBirth
          maritalStatus
          occupation
          countryOfResidency
          acceptsMarketing
          preferredCommunicationChannel
          preferredLanguage
          contacts { type value }
          identities { type value }
          addresses { type fields }
          facts { type value{ stringValue dateValue booleanValue numberValue arrayValue { stringValue } }}
        }

        ... on company {
          __typename
          name
          natureOfBusiness
          registrationNumber
          contacts { type value }
          identities { type value }
          addresses { type fields }
          facts { type value{ stringValue dateValue booleanValue numberValue arrayValue { stringValue } }}
          acceptsMarketing
        }
       }

      #commissions
      commissionSummary {
        type
        currencyCode
        amount
        entity{
          name
        }
        ratio
      }

      transactions{
        id
        formattedTransaction
        currencyCode
        dateTime
        amount
        status
        method
      }

      status
      cancellationReason
      cancelledBy{
        username
        associatedUser{
          name
        }
      }
      startDate
      endDate
      issueDate
      referrer{ name internalCode }
      
      contractInsured {
        ... on individual {
          __typename
          name
          gender
          salutation
          englishFirstName
          englishLastName
          chineseFirstName
          chineseLastName
          dateOfBirth
          maritalStatus
          occupation
          countryOfResidency
          acceptsMarketing
          preferredCommunicationChannel
          preferredLanguage
          contacts { type value }
          identities { type value }
          addresses { type fields }
          facts { type value{ stringValue dateValue booleanValue numberValue arrayValue { stringValue } }}
        }

        ... on object {
          __typename
          name
          addresses { type fields }
          facts { type value{ stringValue dateValue booleanValue numberValue arrayValue { stringValue } }}
        }
      } 
      otherContractHolders {
        ... on individual {
          __typename
          name
          gender
          salutation
          englishFirstName
          englishLastName
          chineseFirstName
          chineseLastName
          dateOfBirth
          maritalStatus
          occupation
          countryOfResidency
          acceptsMarketing
          preferredCommunicationChannel
          preferredLanguage
          contacts { type value }
          identities { type value }
          addresses { type fields }
          facts { type value{ stringValue dateValue booleanValue numberValue arrayValue { stringValue } }}
        }
      }

      notes{
        id
        title
        content
        createdAt
        createdBy{
          username
        }
        lastModifiedBy{
          username
        }
      }
    }
  }
}
`

const numberOfClaims = `
query numberOfClaims($where: claimWhereInput){
  claims(where: $where){
    totalCount
  }
} 
`

const readAllClaims = `
query readAllClaims($skip: Int, $limit: Int, $sort: sortInput, $where: claimWhereInput){
  claims(skip: $skip, limit: $limit, sort: $sort, where: $where){
    list{
      id
      issuerNumber
      status
      benefitClaims{
        benefit{
          typeId
        }
        totalValues{
          billedAmount
          approvedAmount
        }
      }
      diagnosisCodes{
        code
      }
      operationCodes{
        code
      }
      provider{
        internalCode
      }
      facts{
        id
        type
        value{
          stringValue
          numberValue
          booleanValue
          dateValue
        }
      }
      policy{
        issuerNumber
        acceptedOffer{
          product{ 
            productId { plan }
          }
        }
        contractInsured{
          ...on individual{
            gender
            dateOfBirth
          }
        }
      }
      provider{
        internalCode
      }
      transactions{
        dateTime
      }
      rejectionCodes{
        code
        name
      }
    }
  }
} 
`

const readClaimRejectionSettings = `
query readClaimRejectionSettings($where: productWhereInput){
  products_2(where: $where){
    list{
      claimSettings{
        rejectionSettings{
          codeNames{
            code
            name
          }
        }
      }
    }
  }
} 
`

const query = {
	numberOfIndividuals,
	readAllIndividuals,
	numberOfCompanies,
	readAllCompanies,
	numberOfPolicies,
	readAllQuotes,
	readAllPolicies,
	numberOfClaims,
	readAllClaims,
	readClaimRejectionSettings
}

const mutation = {}

export { query, mutation }
